import JsonRawContainer from "../../../components/json_raw_container";
import h from "../../../core/createElement";
import popupAlerts from "../../../core/popupAlerts";

export default function JsonContainer({ shared = {}, name = "json_container", onChangeObject }) {
    const inner_shared = {};

    const validate_json = (v) => {
        if (!v) {
            popupAlerts.warning("Sintaxe json inválida!");
            inner_shared.json_field.invalid(true);
            return null;
        };

        onChangeObject && onChangeObject(v);
    };

    shared[name] = {
        patch_values: (v) => inner_shared.json_field.setValue(v)
    };

    return <JsonRawContainer shared={inner_shared} name="json_field" onChange={v => validate_json(v)} />;
};
